<template>
    <single-selection-list :items="items" :is-loading="isLoading" :pagination="pagination" @page-number-select="onPageNumberSelect">
    <template slot="is-empty">
      {{ $t('system.no{label}Found', { label: $t('label.recentSelections') }) }}
    </template>
  </single-selection-list>
</template>

<script>
import { uniqBy } from 'lodash'

import businessService from 'Services/BusinessService'

import { paginate } from '@/mixins/helpers'
import { recent } from '@/views/Context/Mixins'

import SingleSelectionList from '@/views/Context/Components/SingleSelectionList.vue'

export default {
  name: 'RecentSelector',

  components: { SingleSelectionList },

  mixins: [ paginate, recent ],

  methods: {
    /**
     * Get recent items.
     */
    getItems () {
      return Promise.resolve(this.recentItems || [])
    },

   /**
     * Get business if it not exist inside session storage
     */
    getBusiness (businessId) {
      const key = `businesses`

      const businesses = this.$sessionStorage.get(key, [])

      return new Promise(resolve => { businesses.some(business => business.businessId === businessId) ? resolve(businesses.find(business => business.businessId === businessId)) : businessService.get(businessId).then(({ businessId, businessName }) => { this.$sessionStorage.set(key, [...businesses, { businessId, businessName }]); resolve({ businessId, businessName }) }) })
    },

   /**
     * Get merchant if it not exist inside session storage
     */
    getMerchant (businessId, merchantId) {
      const key = `merchants`

      const merchants = this.$sessionStorage.get(key, [])

      return new Promise(resolve => { merchants.some(merchant => merchant.merchantId === merchantId) ? resolve(merchants.find(merchant => merchant.merchantId === merchantId)) : businessService.getMerchant({ business: { id: businessId }, merchant: { id: merchantId } }).then(({ merchantId, merchantName }) => { this.$sessionStorage.set(key, [...merchants, { merchantId, merchantName }]); resolve({ merchantId, merchantName }) }) })
    },

    /**
     * Map item value
     */
    mapItems (items) {
      return new Promise((resolve) => {
        const uniqIds = [...uniqBy(items.map(item => ({ businessId: item.businessId })), item => item.businessId), ...uniqBy(items.filter(item => typeof item.merchantId !== 'undefined').map(item => ({ businessId: item.businessId, merchantId: item.merchantId })), item => item.merchantId)]

        Promise.all(
          uniqIds.map(({ businessId, merchantId }) =>
            merchantId
            ? this.getMerchant(businessId, merchantId)
            : this.getBusiness(businessId)
          )
        ).then(policies => {
          resolve(items.map(item => {
            const { businessId, businessName } = policies.find(policy => policy.businessId === item.businessId)
            const { merchantId, merchantName } = policies.find(policy => policy.merchantId === item.merchantId)

            return { businessId, businessName, merchantId, merchantName }
          }))
        })
      })
    }
  }
}
</script>
